export const OAUTH_RETURN_PATH_KEY = 'skyspaceOAuthReturnPath';
export const MODERN_OAUTH_RETURN_PATH = '/modern/';
export const OAUTH_CALLBACK_TIMEOUT_MS = 30_000;

function hasOAuthResponse(params: URLSearchParams): boolean {
  return Boolean(
    params.get('state')
    && (params.get('code') || params.get('error')),
  );
}

export function oauthCallbackParams(
  hash: string,
  search: string,
): URLSearchParams | undefined {
  const fragment = new URLSearchParams(hash.replace(/^#/, ''));
  if (hasOAuthResponse(fragment)) return fragment;
  const query = new URLSearchParams(search.replace(/^\?/, ''));
  return hasOAuthResponse(query) ? query : undefined;
}

export function cleanOAuthCallbackUrl(pathname: string): string {
  return modernApplicationPath(pathname);
}

export function finishOAuthCallbackNavigation(pathname: string): void {
  history.replaceState(null, '', cleanOAuthCallbackUrl(pathname));
  window.dispatchEvent(new PopStateEvent('popstate'));
}

export async function withOAuthCallbackTimeout<T>(
  promise: Promise<T>,
  timeoutMs = OAUTH_CALLBACK_TIMEOUT_MS,
): Promise<T> {
  let timeout: ReturnType<typeof setTimeout> | undefined;
  try {
    return await Promise.race([
      promise,
      new Promise<never>((_resolve, reject) => {
        timeout = setTimeout(() => {
          reject(new Error('SkySpace could not finish signing you in. Please try again.'));
        }, timeoutMs);
      }),
    ]);
  } finally {
    if (timeout !== undefined) clearTimeout(timeout);
  }
}

export function modernApplicationPath(pathname: string): '/' | '/modern/' {
  return pathname === '/modern' || pathname.startsWith('/modern/')
    ? MODERN_OAUTH_RETURN_PATH
    : '/';
}

export function modernOAuthRedirectUri(origin: string, pathname: string): string {
  const applicationPath = modernApplicationPath(pathname);
  return applicationPath === '/'
    ? origin
    : `${origin}${applicationPath}`;
}
